<script lang="ts">
	interface Props {
		id: string
		visiblePartLength: number
	}

	let { id, visiblePartLength }: Props = $props()
</script>

<div class="relative overflow-hidden whitespace-nowrap">
	{id.substring(0, visiblePartLength)}&hellip;{id.substring(id.length - visiblePartLength)}
	<div class="absolute top-0 left-0 text-transparent" aria-hidden="true">
		{id}
	</div>
</div>
